export default __webpack_public_path__ + "assets/png/c99c2aacd81aca3c46fea9ed2c46a347.png";